const locationObjectToLocationRequest = (object) => {
    const dimensions = {
        length: object.length,
        width: object.width,
        height: object.height,
        dimensionsUnit: object.dimensionsUnit
    };

    const weight = {
        weight: object.weight,
        weightUnit: object.weightUnit
    };

    return {
        id: object.id,
        name: object.name,
        warehouse_id: object.warehouseId,
        location_type: object.locationType,
        dimensions: dimensions,
        weight: weight
    };
};

const locationResponseToLocationObject = (response, warehouses) => {
    const warehouse = warehouses?.find(w => w.id === response.warehouse_id);
    return {
        id: response.id,
        userId: response.user_id,
        createdAt: response.created_at,
        name: response.name,
        warehouseId: response.warehouse_id,
        warehouseName: warehouse?.name,
        locationType: response.location_type,
        length: response.dimensions?.length,
        width: response.dimensions?.width,
        height: response.dimensions?.height,
        dimensionsUnit: response.dimensions?.dimensions_unit,
        weight: response.weight?.weight,
        weightUnit: response.weight?.weight_unit
    };
};

export { locationResponseToLocationObject, locationObjectToLocationRequest };
